import axios from "axios";

const REACT_APP_EZORDER_API = process.env.REACT_APP_EZORDER_API;

export default axios.create({
  baseURL: REACT_APP_EZORDER_API
    ? REACT_APP_EZORDER_API
    : "http://localhost:8080",
});
